import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import PoiCouponA from '../PoiCouponA/script';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const domId = createUniqueId();

const renderPoiCouponAList = (props) => {
    const component = PoiCouponAList({ ...props });
    dom.$id(domId).outerHTML = component;
};

const PoiCouponAList = (props = {}) => {
    const { poiList, isLazyLoadImg = false, onPoiCouponClick } = props;
    const data = {
        domId,
        poiList,
        renderPoiInfo: (info, index) => {
            const res = PoiCouponA({
                info,
                index,
                isLazyLoadImg,
                onPoiCouponClick,
            });
            return res;
        },
    };
    const events = {};
    const component = createComponent(tpl, { data, style, props }, events);

    return component;
};

export default PoiCouponAList;
export { renderPoiCouponAList };
